import React from "react"
import initialState from "./state"

const WindowCtx = React.createContext({
  ...initialState,
})

export default WindowCtx
